import { render } from "./LeaveTable.vue?vue&type=template&id=3363579e&scoped=true"
import script from "./LeaveTable.vue?vue&type=script&lang=js"
export * from "./LeaveTable.vue?vue&type=script&lang=js"

import "./LeaveTable.vue?vue&type=style&index=0&id=3363579e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3363579e"]])

export default __exports__